import Swiper from "swiper";
import Chart from "chart.js";

export default {
    init() {

        const $html = $("html");
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // browser check
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */

        // Opera 8.0+
        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
        if (isOpera == true) {
            $html.addClass("opera");
        }

        // Firefox 1.0+
        var isFirefox = typeof InstallTrigger !== "undefined";
        if (isFirefox == true) {
            $html.addClass("firefox");
        }

        // Safari 3.0+ "[object HTMLElementConstructor]"
        var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
            return p.toString() === "[object SafariRemoteNotification]";
        })(!window["safari"] || (typeof safari !== "undefined" && safari.pushNotification));
        if (isSafari == true) {
            $html.addClass("safari");
        }

        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        if (isIE == true) {
            $html.addClass("ie");
        }

        // Edge 20+
        var isEdge = !isIE && !!window.StyleMedia;
        if (isEdge == true) {
            $html.addClass("edge");
        }

        // Chrome 1+
        var isChrome = !!window.chrome && !!window.chrome.webstore;
        if (isChrome == true) {
            $html.addClass("chrome");
        }

        // iOS
        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (isIOS) {
            $html.addClass("ios");
        }


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // header
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        const lngDD = document.querySelector('.lang-dd');
        const langDropdown = document.querySelector('.lang-dd button');
        const lng_menu = document.querySelector('ul.lang-submenu');
        let menuOpenLang = false;

        // Language Text variables
        const {closeText, defaultText, openText} = GLOBAL?.menu;
        $(".btn-hamburger").on("click", function(e) {
            e.preventDefault();
            $(this).toggleClass("is-active");

            if ($(this).hasClass("is-active")) {
                $("nav.primary").addClass("open");
                $("body").addClass("no-scroll");
                $(".btn-hamburger").attr("aria-expanded", true);
                $(".btn-hamburger span").text(closeText);
                $("nav.primary li:first-of-type a").focus();
                lngDD.style.display = "none";
            }
            else {
                $("nav.primary").removeClass("open");
                $("body").removeClass("no-scroll");
                $(".btn-hamburger").attr("aria-expanded", false);
                $(".btn-hamburger span").text(defaultText);
                lngDD.style.display = "inline-flex";
            }
        });

        function subMenu() {
            if (window.innerWidth < 1281) {
                $(document).off("nav.primary > ul > li > .arrow-btn");
                $(document).on("click", "nav.primary > ul > li > .arrow-btn", function(e) {
                    if ($(this).prev().hasClass("open")) {
                        $(this).prev().removeClass("open");
                        $(this).parent().next().removeClass("open");
                        $(this).parent().removeClass("open");
                    }
                    else {
                        $(this).prev().addClass("open");
                        $(this).next().addClass("open");
                        $(this).parent().addClass("open");
                    }
                    e.preventDefault();
                });

                $(document).off("nav.primary > ul > li.anchor-item > a");
                $(document).on("click", "nav.primary > ul > li.anchor-item > a", function(e) {
                    if ($(this).hasClass("open")) {
                        $(this).removeClass("open");
                        $(this).next().next().removeClass("open");
                    }
                    else {
                        $(this).addClass("open");
                        $(this).next().next().addClass("open");
                    }
                    e.preventDefault();
                });

                $(document).off("nav.primary > ul > li > ul .back");
                $(document).on("click", "nav.primary > ul > li > ul .back", function(e) {
                    $("nav.primary > ul > li > ul.submenu").removeClass("open");
                    $("nav.primary > ul > li").removeClass("open");
                    $("nav.primary > ul > li a.parent_link").removeClass("open");
                    e.preventDefault();
                });
            }
        }

        subMenu();

        $(window).on("resize", function() {
            subMenu();
        });

        if (lng_menu) {
            const lng_menuLinks = lng_menu.querySelectorAll(
                'a[href]:not([disabled]), button:not([disabled])'
            );

            lng_menuLinks.forEach(link => {
                link.setAttribute('tabindex', '-1');
            });
        }

        function langMenu (e) {
            e.preventDefault();
            e.stopPropagation();

            const lng_menuLinks = lng_menu.querySelectorAll('a, button');

            if (langDropdown.classList.contains('open')) {
                langDropdown.classList.remove('open');
                langDropdown.nextElementSibling.classList.remove('open');

                menuOpenLang = false;
                langDropdown.setAttribute("aria-expanded", "false");
                lng_menu.setAttribute("aria-hidden", "true");

                lng_menuLinks.forEach(link => {
                    link.setAttribute('tabindex', '-1');
                });
            } else {
                langDropdown.classList.add('open');
                langDropdown.nextElementSibling.classList.add('open');

                menuOpenLang = true;
                trapFocus(lng_menu, menuOpenLang, langDropdown);
                langDropdown.setAttribute("aria-expanded", "true");
                lng_menu.setAttribute("aria-hidden", "false");

                lng_menuLinks.forEach(link => {
                    link.setAttribute('tabindex', '0');
                });
            }
        }

        if (langDropdown) {
            langDropdown.addEventListener('click', langMenu);
        }

        function langMenuClose (e) {
            if(lng_menu) {
                const lng_menuLinks = lng_menu.querySelectorAll('a, button');

                langDropdown.classList.remove('open');
                langDropdown.nextElementSibling.classList.remove('open');

                menuOpenLang = false;
                langDropdown.setAttribute("aria-expanded", "false");
                lng_menu.setAttribute("aria-hidden", "true");

                lng_menuLinks.forEach(link => {
                    link.setAttribute('tabindex', '-1');
                });
            }
        }

        function langMenuEscClose (e) {
            if (e.key === "Escape") {
                if (langDropdown.classList.contains('open')) {
                    const lng_menuLinks = lng_menu.querySelectorAll('a, button');

                    langDropdown.classList.remove('open');
                    langDropdown.nextElementSibling.classList.remove('open');

                    menuOpenLang = false;
                    langDropdown.setAttribute("aria-expanded", "false");
                    lng_menu.setAttribute("aria-hidden", "true");

                    lng_menuLinks.forEach(link => {
                        link.setAttribute('tabindex', '-1');
                    });
                }
            }
        }

        $html.on('click', () => langMenuClose());

        document.addEventListener("keyup", langMenuEscClose);

        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // buttons
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        $(document).on("mousedown", "a, button, input, select, textarea, .dropdown__results-item-text", function() {
            $(this).addClass("active-link");
        }).on("blur", "a, button, input, select, textarea, .dropdown__results-item-text", function() {
            $(this).removeClass("active-link");
        });


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // a11y primary nav
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        const topLevelLinks = document.querySelectorAll(".parent_link");

        topLevelLinks.forEach(link => {
            if (link.nextElementSibling) {
                link.addEventListener("focus", function() {
                    $("nav.primary > ul > li").removeClass("has-focus");
                    this.parentElement.classList.add("has-focus");
                });

                const subMenu = link.nextElementSibling.nextElementSibling;
                const subMenuLinks = subMenu.querySelectorAll("a");
                const lastLinkIndex = subMenuLinks.length - 1;
                const lastLink = subMenuLinks[lastLinkIndex];

                if(lastLink) {
                    lastLink.addEventListener("blur", function() {
                        link.parentElement.classList.remove("has-focus");
                    });
                }
            }
        });

        $(window).on("resize", function() {
            $("nav.primary > ul > li").removeClass("has-focus");
        });


        function a11yForMenus() {
            const dropdownArrows = document.querySelectorAll("#primary_navigation button.arrow-btn");
            const subMenus = document.querySelectorAll("#primary_navigation ul.submenu");
            const subMenuItems = document.querySelectorAll("#primary_navigation ul.submenu li a");
            const mblBackButtons = document.querySelectorAll('#primary_navigation ul.submenu button.back')
            let tbltMenuLinks = document.querySelectorAll('.header-top a.logo, #btn-hamburger, #primary_navigation .header__item > a, .header-bottom .nav-wrapper button.btn-trials')
            let mblMenuLinks = document.querySelectorAll('.header-top a.logo, #btn-hamburger, #primary_navigation .header__item > a, #primary_navigation button.btn-trials-mobile')
            let activeSubmenu;

            if (window.innerWidth >= 1281) {
                // desktop dropdown arrows open, change aria label
                dropdownArrows.forEach(arrow => {
                    const arrowParent = arrow.parentElement;
                    arrowParent.addEventListener('mouseenter',  function(e) {
                        if (arrow.getAttribute('aria-expanded') == "false") {
                            arrow.setAttribute('aria-expanded', 'true')
                        }
                    })

                    arrowParent.addEventListener('mouseleave',  function(e) {
                        if (arrow.getAttribute('aria-expanded') == "true") {
                            arrow.setAttribute('aria-expanded', 'false')
                        }
                    })

                    // on keypress
                    arrow.addEventListener("keypress", function(e) {
                        e.preventDefault();
                        if (e.which == 13) {
                            if (arrow.getAttribute('aria-expanded') == "true") {
                                arrow.setAttribute('aria-expanded', 'false')
                            } else if (arrow.getAttribute('aria-expanded') == "false") {
                                dropdownArrows.forEach(otherArrows => {
                                    otherArrows.setAttribute('aria-expanded', 'false')
                                })
                                arrow.setAttribute('aria-expanded', 'true')
                            }
                        }
                    })
                });

                //close submenu if Esc is pressed
                subMenuItems.forEach(item => {
                    let thisParentSibling = item.parentElement.parentElement.previousElementSibling
                    item.addEventListener("keydown", function(e) {
                        if(e.key === 'Escape') {
                            console.log(item)
                            thisParentSibling.setAttribute('aria-expanded', 'false')
                        }
                    })
                })
            } else {
                // mobile nav stuff!!
                // open submenu on enter
                dropdownArrows.forEach(arrow => {
                    const nextSubnavSib = arrow.nextElementSibling;

                    arrow.addEventListener("keydown", function(e) {
                        if (e.which == 13) {
                            if (arrow.getAttribute('aria-expanded') == "false") {
                                arrow.setAttribute('aria-expanded', 'true')
                                nextSubnavSib.classList.add('open')
                            }
                        }
                    })
                })

                // capture focus in mobile nav submenu
                subMenus.forEach(menu => {
                    let links = menu.querySelectorAll('li > button, li > a')

                    links.forEach(item => {
                        item.addEventListener('keydown', function(e) {
                            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                            if (!isTabPressed) {
                                return;
                            } else if (e.shiftKey && isTabPressed) { // if shift key pressed for shift + tab combination
                                return;
                            } else if (isTabPressed) { // if tab key is pressed
                                if (document.activeElement==links[links.length-1]) {
                                    links[0].focus() // add focus for the last focusable element
                                    e.preventDefault()
                                }
                            }
                        })
                    })
                })

                if(window.innerWidth >= 768) {
                    // capture focus in mobile menu (tablet and mobile versions)
                    tbltMenuLinks.forEach(item => {
                        item.addEventListener('keydown', function(e) {
                            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                            if (!isTabPressed) {
                                return;
                            } else if (e.shiftKey && isTabPressed) { // if shift key pressed for shift + tab combination
                                return;
                            } else if (isTabPressed) { // if tab key is pressed
                                if (document.activeElement==tbltMenuLinks[tbltMenuLinks.length-1] && document.querySelector('#primary_navigation').classList.contains('open')) {
                                    tbltMenuLinks[0].focus() // add focus for the last focusable element

                                    e.preventDefault()
                                }
                            }
                        })
                    })
                } else {
                    mblMenuLinks.forEach(item => {
                        item.addEventListener('keydown', function(e) {
                            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                            if (!isTabPressed) {
                                return; // some other button entirely
                            } else if (e.shiftKey && isTabPressed) { // if shift key pressed for shift + tab combination
                                return;
                            } else if (isTabPressed) { // if tab key is pressed
                                if (document.activeElement==mblMenuLinks[mblMenuLinks.length-1]) {
                                    mblMenuLinks[0].focus() // add focus to the first focusable element

                                    e.preventDefault()
                                }
                            }
                        })
                    })
                }


                // back button pressed, menu closes
                mblBackButtons.forEach(item => {
                    item.addEventListener("keypress", function(e) {
                        e.preventDefault();
                        if (e.which == 13) {
                            item.parentElement.parentElement.classList.remove('open')
                            item.parentElement.parentElement.previousElementSibling.setAttribute('aria-expanded', 'false')
                            item.parentElement.parentElement.previousElementSibling.previousElementSibling.focus()
                        }
                    })
                })
            }
        }

        a11yForMenus();

        $(window).on("resize", function() {
            a11yForMenus();
        });


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // scrollto
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        const scrollMenu = () => {
            let headerHeight = $("header").outerHeight();
            $(".scrollto").off();
            $(".scrollto").on("click", function(e) {
                e.preventDefault();
                let section = $(this).attr("href");
                $("html, body").off();
                $("html, body").animate({
                    scrollTop: $(section).offset().top - headerHeight + "px"
                }, 1000);
            });
        };
        scrollMenu();

        $(window).on("resize", () => scrollMenu());


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // trial megamenu
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        const btnTrials = document.querySelector("header .btn-trials");
        const navPrimary = document.getElementById("primary_navigation");
        const btnHamburger = document.getElementById("btn-hamburger");
        const bodySelect = document.body;

        /**
         * Adds the active and open class to the element target and the megamenu
         * @param elmTarget The element target
         * @param megaMenu  The megamenu
         */
        const removeMenuClasses = (elmTarget, megaMenu = document.querySelector(".megamenu")) => {
            elmTarget.classList.remove("active");
            megaMenu.classList.remove("open");
        };
        /**
         * Removes the active and open class to the element target and the megamenu
         * @param elmTarget The element target
         * @param megaMenu  The megamenu
         */
        const addMenuClasses = (elmTarget, megaMenu = document.querySelector(".megamenu")) => {
            elmTarget.classList.add("active");
            megaMenu.classList.add("open");
        };

        $(btnTrials).on("click", (elm) => {
            elm.preventDefault();
            elm.stopPropagation();
            const elmTarget = elm.currentTarget;
            const megaMenu = document.querySelector(".megamenu");

            if (megaMenu.classList.contains("open")) removeMenuClasses(elmTarget);
            else addMenuClasses(elmTarget);

            if (navPrimary.classList.contains("open")) {
                navPrimary.classList.remove("open");
                const submenuElms = navPrimary.querySelectorAll("ul.submenu");
                const parentLinkElms = navPrimary.querySelectorAll("a[class^=\"parent_link\"]");

                submenuElms.length && [...submenuElms].forEach(ulElm => ulElm.classList.remove("open"));
                parentLinkElms.length && [...parentLinkElms].forEach(parentLink => parentLink.classList.remove("open"));

                bodySelect.classList.remove("no-scroll");
                btnHamburger.classList.remove("is-active");
            }
        });

        $("header .megamenu").on("click", (e) => e.stopPropagation());

        $("nav.primary .megamenu form .form-footer .col-6:last-child a:last-child").on("blur", () => removeMenuClasses(btnTrials));
        $("nav.primary > ul > li:last-child a").on("focus", () => removeMenuClasses(btnTrials));
        $html.on("click", () => removeMenuClasses(btnTrials));

        // mobile
        $("header .btn-trials-mobile").on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            $("#trial-dd").addClass("open");
            $('#primary_navigation ul li > a, #primary_navigation button').attr('tabindex', -1)
        });

        $(".megamenu .back-btn a.back").on("click", (e) => {
            e.preventDefault();
            $(".megamenu").removeClass("open");
            $('#primary_navigation ul li > a, #primary_navigation button').attr('tabindex', 0)
        });

        // region Confused on what this is meant to do
        const trialMenuFlip = () => {
            const formTop = $(".megamenu form .form-top");
            const formBody = $(".megamenu form .form-body");
            if (window.innerWidth < 767) {
                if (formTop.children("ul").length) {
                    let links = formTop.children("ul");
                    formTop.children("ul").remove();
                    formBody.append(links);
                }
            }
            else {
                if (formBody.children("ul").length) {
                    let links = formBody.children("ul");
                    formBody.children("ul").remove();
                    formTop.append(links);
                }
            }
        };
        trialMenuFlip();

        $(window).on("resize", function() {
            trialMenuFlip();
        });
        //endregion


        // reset filter dropdowns
        const resetButton = document.querySelector('.trials-filters .reset');

        function resetDropdowns() {
            $('.custom-a11yselect-container .custom-a11yselect-menu .custom-a11yselect-option').each(function(){
                $(this).removeClass('custom-a11yselect-selected custom-a11yselect-focused');
            });
           const dropdownAllText = $('.trials-filters .select-items').attr('data-ddtext');

            $('.custom-a11yselect-text').each(function(){
                $(this).text(dropdownAllText);
            });
            $('.custom-a11yselect-container .custom-a11yselect-btn').attr('aria-expanded', false);
            $('.custom-a11yselect-container .custom-a11yselect-btn').attr('aria-activedescendant', '');
            $("select").each(function() { this.selectedIndex = 0 });
        }

        if (resetButton) {
            resetButton.addEventListener('click', resetDropdowns);
        }


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // mobile filters
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        $(".filters-toggle").on("click", function(e) {
            e.preventDefault();
            $(".trials-filters").addClass("open");
            $("body").addClass("no-scroll");
            $(".filters-toggle").attr("aria-expanded", true);
        });

        $(".filters-close").on("click", function(e) {
            e.preventDefault();
            $(".trials-filters").removeClass("open");
            $("body").removeClass("no-scroll");
            $(".filters-toggle").attr("aria-expanded", false);
        });

        $(".trials-filters .inputs input[type=submit]").on("click", function() {
            $(".trials-filters").removeClass("open");
            $("body").removeClass("no-scroll");
            $(".filters-toggle").attr("aria-expanded", false);
        });


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // form
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        jQuery("select").customA11ySelect();

        jQuery(document).on("gform_page_loaded", function(event, form_id, current_page) {
            $("select").customA11ySelect();
        });


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // form
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        $(".print-email button.print").on("click", function(e) {
            e.preventDefault();
            window.print();
        });


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // phase carousel
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        if ($(".phase-carousel").length) {
            var timer;

            function initSwiper () {
                // Language variables for WPML
                const {
                    firstSlide,
                    lastSlide,
                    nextSlide,
                    previousSlide,
                    slideIndex,
                } = GLOBAL.slider;

                $('.phase-carousel .swiper-container').each(function (i) {
                    // Store the current active index before destroying
                    let currentIndex = 0;
                    if (this.swiper) {
                        currentIndex = this.swiper.activeIndex;
                        this.swiper.destroy(true, true);
                    }

                    const swiperParams = {
                        loop: true,
                        speed: 1000,
                        slidesPerView: 1,
                        centeredSlides: false,
                        touchStartPreventDefault: false,
                        preventClicks: true,
                        spaceBetween: 47,
                        simulateTouch: true,
                        autoHeight: false,
                        slideToClickedSlide: false,

                        keyboard: {
                            enabled: true,
                            onlyInViewport: true,
                        },
                        navigation: {
                            prevEl: '.swiper-button-prev',
                            nextEl: '.swiper-button-next',
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true,
                            renderBullet: function (index, className) {
                                const slideTitle = this.$el[0].querySelectorAll('.phase-header')[index]?.dataset.phaseTitle || '';
                                return '<p class="' + className + '">' + slideTitle + '</p>';
                            },
                        },
                        a11y: {
                            prevSlideMessage: previousSlide,
                            nextSlideMessage: nextSlide,
                            firstSlideMessage: firstSlide,
                            lastSlideMessage: lastSlide,
                            paginationBulletMessage: slideIndex + ' {{index}}',
                        },
                        watchSlidesProgress: true,
                        loopAdditionalSlides: 2,
                        loopedSlides: 4,
                        allowTouchMove: true,
                        touchRatio: 1,
                        threshold: 20,
                        breakpoints: {
                            1024: {
                                slidesPerView: 1,
                                centeredSlides: false,
                                spaceBetween: 47,
                            },
                            768: {
                                slidesPerView: 1,
                                centeredSlides: true,
                                spaceBetween: 16,
                                loopedSlides: 2,
                                touchRatio: 0.8,
                            },
                            300: {
                                slidesPerView: 1,
                                centeredSlides: true,
                                spaceBetween: 16,
                                loopedSlides: 2,
                                touchRatio: 0.8,
                            },
                        },
                        on: {
                            init: function () {},
                            slideChangeTransitionEnd: function () {
                                const index_currentSlide = this.realIndex;
                                const thisSwiper = $(this)[0].$el;
                                const swiperParent = thisSwiper.parent();
                                const thisPagi =
                                    swiperParent[0].querySelector('.swiper-pagination');
                                const thisActive = thisPagi.children;
                                setTimeout(function () {
                                    for (i = 0; i < thisActive.length; i++) {
                                        thisActive[i].setAttribute(
                                            'aria-current',
                                            'false'
                                        );
                                        thisActive[i].setAttribute(
                                            'disable',
                                            false
                                        );
                                    }
                                    thisActive[index_currentSlide].setAttribute(
                                        'aria-current',
                                        'true'
                                    );
                                    thisActive[index_currentSlide].setAttribute(
                                        'disable',
                                        true
                                    );
                                }, 200);
                            },
                        },
                    };

                    // Initialize new swiper instance
                    const newSwiper = new Swiper(this, swiperParams);

                    // Set the slide to the previous position
                    if (currentIndex > 0) {
                        newSwiper.slideTo(currentIndex, 0);
                    }
                });
            }

            // Initial load
            initSwiper();

            // Handle resize with debounce
            window.addEventListener('resize', function() {
                if (timer) {
                    clearTimeout(timer);
                }

                timer = setTimeout(initSwiper, 200);
            });
        }


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // accordion toggle
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        $(".accordion-toggle button.expand").on("click", function(e) {
            $(".accordion .accordion-item .accordion-trigger").attr("aria-expanded", true);
            $(".accordion-panel").removeAttr("hidden");
        });
        $(".accordion-toggle button.collapse").on("click", function(e) {
            $(".accordion .accordion-item .accordion-trigger").attr("aria-expanded", false);
            $(".accordion-panel").attr("hidden", true);
        });


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // therapeutic mobile
        /*
        /* //////////////////////////////////////////////////////////////////////////// */

        /* //////////////////////////////////////////////////////////////////////////// */
        function terapeuticMobile() {
            if (window.innerWidth < 768) {
                $(".therapeutic-box h3 button").off();
                $(".therapeutic-box h3 button").on("click", function(e) {
                    e.preventDefault();
                    if ($(this).hasClass("open")) {
                        $(this).removeClass("open");
                        $(this).parent().next().slideUp(400);
                    }
                    else {
                        $(this).addClass("open");
                        $(this).parent().next().slideDown(400);
                    }
                });
            }
        }

        terapeuticMobile();

        $(window).on("resize", function() {
            terapeuticMobile();
        });


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // anchors toggle
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        const anchorToggle = () => {
            if (window.innerWidth < 767) {
                $(".anchors .anchors-toggle").off();
                $(".anchors .anchors-toggle").on("click", function(e) {
                    e.preventDefault();
                    if ($(this).hasClass("open")) {
                        $(this).removeClass("open");
                        $(this).next().slideUp(400);
                    }
                    else {
                        $(this).addClass("open");
                        $(this).next().slideDown(400);
                    }
                });

                $(".anchors ul li a").on("click", function(e) {
                    $(".anchors .anchors-toggle").removeClass("open");
                    $(".anchors ul").slideUp(400);
                });
            }
        };

        anchorToggle();

        $(window).on("resize", () => anchorToggle());


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // responsive flip
        /*
        /* //////////////////////////////////////////////////////////////////////////// */

        /* //////////////////////////////////////////////////////////////////////////// */
        function contentPhotoFlip() {
            const contentPhoto = document.querySelectorAll(".content-photo");
            let photo;

            contentPhoto.forEach(element => {
                let row = element.children;
                if (window.innerWidth < 768) {
                    if ($(row).children(".col-6:last-child").children("div").hasClass("photo")) {
                        photo = $(row).children(".col-6:last-child");
                        $(row).children(".col-6:last-child").remove();
                        $(row).prepend(photo);
                    }
                }
                else {
                    if ($(row).children(".col-6:first-child").children("div").hasClass("photo")) {
                        photo = $(row).children(".col-6:first-child");
                        $(row).children(".col-6:first-child").remove();
                        $(row).append(photo);
                    }
                }
            });
        }

        contentPhotoFlip();

        function photoCTAFlip() {
            const ctaPhoto = document.querySelectorAll(".box.has-photo");
            let photo;

            ctaPhoto.forEach(element => {
                let row = element.children;
                if (window.innerWidth < 768) {
                    if ($(row).children(".col-6:last-child").children("div").hasClass("photo")) {
                        photo = $(row).children(".col-6:last-child");
                        $(row).children(".col-6:last-child").remove();
                        $(row).prepend(photo);
                    }
                }
                else {
                    if ($(row).children(".col-6:first-child").children("div").hasClass("photo")) {
                        photo = $(row).children(".col-6:first-child");
                        $(row).children(".col-6:first-child").remove();
                        $(row).append(photo);
                    }
                }
            });
        }

        photoCTAFlip();

        function trialSearchFlip () {
            if (window.innerWidth < 767) {
                if ($('.trial-search form .form-header').children('a').length) {
                    let links = $('.trial-search form .form-header').children(
                        'a'
                    );
                    $('.trial-search form .form-header').children('a').remove();
                    $('.trial-search form').append(links);
                }
            } else {
                if ($('.trial-search form').children('a').length) {
                    let links = $('.trial-search form').children('a');
                    $('.trial-search form').children('a').remove();
                    $('.trial-search form .form-header').append(links);
                }
            }
        }

        trialSearchFlip();

        function trialResultFlip() {

            const trialResult = document.querySelectorAll(".trial-result");
            let location, trial_id, trial_name, trial_button;

            trialResult.forEach(element => {
                let row = element.children;
                if (window.innerWidth < 768) {
                    if ($(row[1]).children(".col-2").hasClass("location")) {
                        // move location
                        location = $(row[1]).children(".col-2");
                        $(row[1]).children(".col-2").remove();
                        $(row[0]).append(location);

                        // move id
                        trial_id = $(row[0]).children(".col-3");
                        $(row[0]).children(".col-3").remove();
                        $(row[1]).append(trial_id);

                        // move name
                        trial_name = $(row[0]).children(".col-7");
                        $(row[0]).children(".col-7").remove();
                        $(row[0]).append(trial_name);

                        // move button
                        trial_button = $(row[1]).children(".button");
                        $(row[1]).children(".button").remove();
                        $(row[1]).append(trial_button);
                    }
                }
                else {
                    if ($(row[0]).children(".col-2").hasClass("location")) {
                        // move location
                        location = $(row[0]).children(".location");
                        $(row[0]).children(".location").remove();
                        $(row[1]).prepend(location);

                        // move id
                        trial_id = $(row[1]).children(".trial_id");
                        $(row[1]).children(".trial_id").remove();
                        $(row[0]).append(trial_id);
                    }
                }
            });

        }

        trialResultFlip();

        function mapFlip() {
            const locationMap = $(".location-map")
            if (window.innerWidth < 767) {
                if (locationMap.children(".row").children("div:last-child").hasClass("map")) {
                    let map = locationMap.children(".row").children("div:last-child");
                    locationMap.children(".row").children("div:last-child").remove();
                    locationMap.children(".row").prepend(map);
                }
            }
            else {
                if (locationMap.children(".row").children("div:first-child").hasClass("map")) {
                    let map = locationMap.children(".row").children("div:first-child");
                    locationMap.children(".row").children("div:first-child").remove();
                    locationMap.children(".row").append(map);
                }
            }
        }

        mapFlip();

        const removeNoBodyScroll = () => {
            const bodyElm = document.querySelector('body');
            if (window.innerWidth > 767 && bodyElm.classList.contains('no-scroll')) {
                bodyElm.classList.remove('no-scroll');
            }
        }

        $(window).on("resize", function() {
            contentPhotoFlip();
            photoCTAFlip();
            trialSearchFlip();
            trialResultFlip();
            mapFlip();
            removeNoBodyScroll();
        });


        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // pie chart
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */

        $('.js-links').click(function(){
            $(this).parents('.nav-links').find('nav').toggleClass('drop-ul');

            return false;
        });

        navLinks();

        function navLinks() {
            //console.log(window.innerWidth );
            if(window.innerWidth < 768) {
                var textLinks = $('.nav-links ul li a').first().text();
                $('.js-links span').text(textLinks);

                $('.nav-links ul li').click(function(){
                    $(this).parents('nav').removeClass('drop-ul');
                    $('.js-links span').text($(this).find('a').text());
                })
            }
        }

        $( window ).resize(function() {
            navLinks();
        });

        // new

        const page = $('html, body');
        let scrollPos;

        // eligibility modal
        const toggleEligibilityModal = () => {
            const eligibilityModal = $('#eligibility-modal'),
                eligibilityModalUnderlay = $('#eligibility-modal-underlay'),
                eligilibiltyModalOpenBtn = $('.eligibility-btn'),
                headerMenuToggle = $('header__main__mobile-toggle'),
                eligilibiltyModalCloseBtn = $('#eligibility-modal-close'),
                iframe = $('iframe'),
                iframeSrc = $(eligilibiltyModalOpenBtn).attr('data-src');

            let clickedBtn;

            eligilibiltyModalOpenBtn.on('click', function (e) {
                openEligibilityModal();
                clickedBtn = $(this);
                eligilibiltyModalCloseBtn.addClass('active');
                iframe.attr('src', iframeSrc);
                e.preventDefault();
            });

            eligilibiltyModalOpenBtn.on('keydown', function (event) {
                let code = event.key;

                if (code === 'Enter' || code === ' ') {
                    openEligibilityModal();
                    clickedBtn = $(this);
                    eligilibiltyModalCloseBtn.addClass('active');
                    iframe.attr('src', iframeSrc);
                    event.preventDefault();
                }
            });

            eligilibiltyModalCloseBtn.on('click', function (e) {
                $('.modal--exit').addClass('show');
                $('.eligibility-modal__iframe iframe').css(
                    'visibility',
                    'hidden'
                );
                $('.eligibility-modal-close').css('visibility', 'hidden');
                e.preventDefault();
            });

            $('.modal--exit .modal-leave').on('click', function (e) {
                e.preventDefault();
                $('.eligibility-modal__iframe iframe').removeAttr('style');
                $('.eligibility-modal-close').removeAttr('style');
                closeEligibilityModal();
                $('.modal--exit').removeClass('show');
                clickedBtn.addClass('active');
                iframe.attr('src', '');
            });

            $('.modal--exit .modal-no').on('click', function (e) {
                e.preventDefault();
                $('.modal--exit').removeClass('show');
                $('.eligibility-modal__iframe iframe').css(
                    'visibility',
                    'visible'
                );
                $('.eligibility-modal-close').css('visibility', 'visible');
                $('.eligibility-modal-close').focus();
            });

            eligilibiltyModalCloseBtn.on('keydown', function (event) {
                let code = event.key;

                if (code === 'Enter' || code === ' ') {
                    $('.modal--exit').addClass('show');
                    $('.eligibility-modal__iframe iframe').css(
                        'visibility',
                        'hidden'
                    );
                    $('.eligibility-modal-close').css('visibility', 'hidden');
                    $(
                        '.modal--exit .text-cnt .modal__buttons a.modal-no'
                    ).focus();
                    event.preventDefault();
                }
            });

            const trapFocusInModal = () => {
                $(
                    '.screen-reader-shortcut, header a, header button, section a, section button, footer a, footer button'
                ).attr('tabindex', '-1');
            };

            const releaseFocusFromModal = () => {
                $(
                    '.screen-reader-shortcut, header a, header button, section a, section button, footer a, footer button'
                ).attr('tabindex', '0');
            };

            const openEligibilityModal = () => {
                page.addClass('fixed').css('top', scrollPos * -1 + 'px');
                eligibilityModal.show();
                eligibilityModalUnderlay.show();
                eligilibiltyModalCloseBtn.focus();
                trapFocusInModal();
            };

            const closeEligibilityModal = () => {
                page.removeClass('fixed').css('top', '');
                page.scrollTop(scrollPos);
                eligibilityModal.hide();
                eligibilityModalUnderlay.hide();
                releaseFocusFromModal();

                if ($(window).width() < 750) {
                    if (clickedBtn.hasClass('header-eligibility-btn')) {
                        headerMenuToggle.focus();
                    } else {
                        clickedBtn.focus();
                    }
                } else {
                    clickedBtn.focus();
                }
            };
        };

        toggleEligibilityModal();
        // tooltip functionality
        document.addEventListener('DOMContentLoaded', function () {
            function hideTooltip(trigger) {
                const content = trigger.querySelector('.tooltip-content');
                content.style.display = 'none';
                trigger.classList.remove('tooltip-active');
            }

            document.querySelectorAll('.tooltip-trigger').forEach(function (trigger) {
                const content = trigger.querySelector('.tooltip-content');

                function showTooltip() {
                    content.style.display = 'flex';
                    trigger.classList.add('tooltip-active');
                    positionTooltip();
                }

                function positionTooltip() {
                    content.classList.remove('overflow-right', 'overflow-left');

                    const triggerRect = trigger.getBoundingClientRect();
                    const contentRect = content.getBoundingClientRect();
                    const containerRect = trigger.closest('section')?.getBoundingClientRect() || document.body.getBoundingClientRect();

                    if (triggerRect.left - (contentRect.width / 2) < containerRect.left) {
                        content.classList.add('overflow-left');
                    }
                    else if (triggerRect.right + (contentRect.width / 2) > containerRect.right) {
                        content.classList.add('overflow-right');
                    }
                }

                trigger.addEventListener('mouseenter', showTooltip);
                trigger.addEventListener('mouseleave', function(event) {
                    const relatedTarget = event.relatedTarget;
                    if (!content.contains(relatedTarget)) {
                        hideTooltip(trigger);
                    }
                });

                trigger.addEventListener('focus', showTooltip);
                trigger.addEventListener('blur', function(event) {
                    if (!content.contains(event.relatedTarget)) {
                        hideTooltip(trigger);
                    }
                });
            });

            document.querySelectorAll('.tooltip-content').forEach(function (content) {
                content.addEventListener('mouseleave', function() {
                    const trigger = this.closest('.tooltip-trigger');
                    hideTooltip(trigger);
                });
            });

            document.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') {
                    document.querySelectorAll('.tooltip-trigger').forEach(function (trigger) {
                        hideTooltip(trigger);
                    });
                }
            });

            window.addEventListener('resize', function() {
                document.querySelectorAll('.tooltip-trigger').forEach(function(trigger) {
                    const content = trigger.querySelector('.tooltip-content');
                    if (content.style.display === 'flex') {
                        positionTooltip.call(trigger);
                    }
                });
            });
        });

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        /*
        // alert / sticky header
        /*
        /* //////////////////////////////////////////////////////////////////////////// */
        /* //////////////////////////////////////////////////////////////////////////// */
        // @TODO Find out if this is still being used, and what it is for
        let alertMessage = "Images and text used in these mockups are intended to demonstrate placement only, all elements are subject to change.";
        let alert = "<div class=\"alert\">" +
            "<a href=\"#\" class=\"text\">" + alertMessage + "</a>" +
            "<button class=\"close\"><span>Close</span></button>" +
            "</div>";

        if ($("body").hasClass("page-template-template-home")) {
            $("body").prepend(alert);
        }

        function headerHeight(wpAdminBar = false) {
            let height = document.getElementById("header").clientHeight;
            // Account for the wp admin bar
            if (wpAdminBar){
                if (wpAdminBar) height += wpAdminBar.offsetHeight;
                $("header").css("height", height + "px");
            }
        }

        document.addEventListener("DOMContentLoaded", () => {
          const wpAdminBar = document.querySelector("[id=\"wpadminbar\"]");
          headerHeight(wpAdminBar);
          lazyLoading(); // lazy load images
          toggleFaqs(); // toggle FAQs
        });

        let headerTop = $(".header-bottom").offset().top;

        $(document).on("click", ".alert .close", function(e) {
            e.preventDefault();
            $(".alert").remove();
            window.scrollTo(0, 0);
            headerTop = $(".header-bottom").offset().top;
        });

        function stickyHeader() {
            if (window.innerWidth > 1281) {
                let st = $(window).scrollTop();

                if (st < headerTop) {
                    $(".header-bottom").removeClass("fixed");
                }
                else {
                    $(".header-bottom").addClass("fixed");
                }
            }
            else {
                $(".header-bottom").removeClass("fixed");
            }
        }

        $(window).on("scroll", function(e) {
            stickyHeader();
        });

        $(window).on("resize", function(e) {
            headerHeight();
            stickyHeader();
        });

        if ($('.secondary .square-photo + .secondary-cnt').children('.breadcrumbs').length < 1) {
            $('.secondary .square-photo + .secondary-cnt').addClass('no-crumbs');
        }

        const lazyLoading = () => {
          const aboutElm = document.querySelector('.pah__about');
          const downloadElm = document.querySelector('.pah__download');
          const qualifyElm = document.querySelector('.pah__qualify');

          if (aboutElm) {
            const aboutWaypoint = new Waypoint({
              element: aboutElm,
              handler: function (direction) {
                $(this.element).find('img[data-src]').each(function () {
                  let lazyImgSrc = $(this).attr('data-src');
                  $(this).attr('src', lazyImgSrc).addClass('fadein');
                });
              },
              offset: '110%'
            });
          }
          if (downloadElm) {
            const downloadWaypoint = new Waypoint({
              element: downloadElm,
              handler: function (direction) {
                $(this.element).find('img[data-src]').each(function () {
                  let lazyImgSrc = $(this).attr('data-src');
                  $(this).attr('src', lazyImgSrc).addClass('fadein');
                });

                $(this.element).find('source').each(function () {
                  let lazyImgMediaSrc = $(this).attr('data-srcset');
                  $(this).attr('srcset', lazyImgMediaSrc);
                });
              },
              offset: '110%'
            });
          }

          if (qualifyElm) {
            const whyWaypoint = new Waypoint({
              element: qualifyElm,
              handler: function (direction) {
                let lazyImg = $('.pah__qualify__image img');
                let lazyImgSrc = lazyImg.attr('data-src');
                lazyImg.attr('src', lazyImgSrc).addClass('fadein');

                let lazySource = $('.pah__qualify__image source');
                lazySource.each(function () {
                  let lazyImgMediaSrc = $(this).attr('data-srcset');
                  $(this).attr('srcset', lazyImgMediaSrc);
                });
              },
              offset: '110%'
            });
          }
        }

        // toggle faqs
        const toggleFaqs = () => {
        const faqQuestion = $('.question'),
          faqAnswer = $('.answer'),
          faqExpandAll = $('#expand'),
          faqCollapseAll = $('#collapse');

        faqQuestion.click(function () {
          if ($(this).hasClass('open')) {
            $(this).removeClass('open').next().slideUp(300);
          } else {
            $(this).addClass('open').next().slideDown(300);
          }
          faqCollapseAll.removeClass('active');
          faqExpandAll.removeClass('active');
        });

        faqExpandAll.click(function () {
          faqCollapseAll.removeClass('active');
          $(this).addClass('active');
          faqQuestion.addClass('open');
          faqAnswer.slideDown(300);
        });

        faqCollapseAll.click(function () {
          faqExpandAll.removeClass('active');
          $(this).addClass('active');
          faqQuestion.removeClass('open');
          faqAnswer.slideUp(300);
        });
        }

        const createIframe = (element, videoSrc) => {
            const iframe = document.createElement('iframe');
            iframe.setAttribute(
                'src',
                `${videoSrc}?autoplay=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0`
            );
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('class', 'youtube-iframe');
            element.replaceWith(iframe);
        }

        function getAllVideos() {
            const videoPlayerElm = document.getElementsByClassName('youtube-player');
            for (let index = 0; index < videoPlayerElm.length; index++) {
                const videoPlayBtn = videoPlayerElm[index]
                    .querySelector('.youtube-play-btn');

                videoPlayBtn && videoPlayBtn
                    .addEventListener(
                        'click',
                        ({target}) => target && createIframe(target.parentNode, target.parentElement.dataset.id)
                    )
            }
        }

        getAllVideos();

        if ($(".trialChart").length) {
            var charts = document.querySelectorAll(".trialChart");
            [].forEach.call(charts, function (trialCanvas) {
                const trialDataset = trialCanvas.dataset;
                if (trialDataset.chartData !== undefined && trialDataset.chartData.length) {
                    let chartDataArr = JSON.parse(trialDataset.chartData);
                    let chartData = [], chartColors = [];
                    chartDataArr.map(({value, color}) => {
                        chartData.push(parseFloat(value));
                        chartColors.push(color);
                    })

                    const trialData = {
                        datasets: [
                            {
                                data: chartData,
                                backgroundColor: chartColors,
                            }
                        ]
                    };

                    const pieChart = new Chart(trialCanvas, {
                        type: "pie",
                        data: trialData,
                        options: {
                            tooltips: {enabled: false},
                            hover: {mode: null},
                        }
                    });
                }
            });
        }
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const currentUrl = window.location.href.split('#')[0];
                const hash = this.getAttribute('href');
                window.location.href = currentUrl + hash;
            });
        });
    },
};
